import { render, staticRenderFns } from "./VipRechargeForm.vue?vue&type=template&id=cbb8e036&scoped=true&"
import script from "./VipRechargeForm.vue?vue&type=script&lang=js&"
export * from "./VipRechargeForm.vue?vue&type=script&lang=js&"
import style0 from "./VipRechargeForm.vue?vue&type=style&index=0&id=cbb8e036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb8e036",
  null
  
)

export default component.exports